export default __webpack_public_path__ + "static/media/video.dd877f28.mp4";